import { Expose, plainToClass } from 'class-transformer';
import BasketBillingMethod from './BasketBillingMethod';

export default class BillingAccount {
    @Expose() description: string = '';
    @Expose() accountid: string = '';
    @Expose() accounttype: string = '';
    @Expose() cardsuffix: string = '';
    @Expose() cardtype: string = '';
    @Expose() expiration: string = '';
    @Expose() isdefault: boolean = false;
    @Expose() removable: boolean = false;

  constructor(
    description: string,
    accountid: string,
    accounttype: string,
    cardsuffix: string,
    cardtype: string,
    expiration: string,
    isdefault: boolean,
    removable: boolean) {
    this.description = description;
    this.accountid = accountid;
    this.accounttype = accounttype;
    this.cardsuffix = cardsuffix;
    this.cardtype = cardtype;
    this.expiration = expiration;
    this.isdefault = isdefault;
    this.removable = removable;
  }

  isCreditCard = (() => {
        return this.accounttype == "creditCard"
    })

  isGiftCard = (() => {
      return this.accounttype.indexOf("Piada Gift Card") > -1
  })

  toBasketBillingMethod = ((): BasketBillingMethod => {
    const acct = this;
    const bbm = plainToClass(BasketBillingMethod, {
      billingmethod: 'billingaccount',
      billingaccountid: acct.accountid,
      billingAccount: acct
    }, { excludeExtraneousValues: true });

    return bbm;
  })
}

